import React, { Component } from 'react';
import AutoSizer from 'react-virtualized/dist/commonjs/AutoSizer';
import DesktopTable from './DesktopTable';
const mql = width => {
  return window.matchMedia("(min-width: ".concat(width, "px)"));
};
class DefiTable extends Component {
  constructor() {
    super(...arguments);
    this.state = {
      mobile: !mql(this.props.mobileWidth).matches
    };
    this.mediaQueryChanged = () => {
      this.setState({
        mobile: !mql(this.props.mobileWidth).matches
      });
    };
  }
  componentDidMount() {
    mql(this.props.mobileWidth).addListener(this.mediaQueryChanged);
  }
  componentWillUnmount() {
    mql(this.props.mobileWidth).removeListener(this.mediaQueryChanged);
  }
  createWrapperStyling(fontSize) {
    if (this.props.expandedStatus) {
      return {
        height: '100%',
        maxWidth: '100%',
        overflowX: 'hidden',
        paddingTop: '3px',
        fontSize: fontSize ? fontSize : '10px'
      };
    } else {
      return {
        height: '100%'
      };
    }
  }
  render() {
    const _this$props = this.props,
      children = _this$props.children,
      filterCriteria = _this$props.filterCriteria,
      expandedStatus = _this$props.expandedStatus,
      setFilterCriteria = _this$props.setFilterCriteria,
      config = _this$props.config,
      link = _this$props.link,
      adjustHeight = _this$props.adjustHeight,
      preRowRender = _this$props.preRowRender,
      customRowRenderer = _this$props.customRowRenderer,
      onRowClick = _this$props.onRowClick,
      rowHeight = _this$props.rowHeight,
      fontSize = _this$props.fontSize;
    if (this.state.mobile && !expandedStatus) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: '100%'
        },
        "data-testid": "mobile-table"
      }, this.props.mobileTable());
    } else {
      return /*#__PURE__*/React.createElement("div", {
        style: this.createWrapperStyling(fontSize)
      }, /*#__PURE__*/React.createElement(AutoSizer, null, _ref => {
        let height = _ref.height,
          width = _ref.width;
        const adjustedHeight = adjustHeight ? height + adjustHeight : height - 103;
        return /*#__PURE__*/React.createElement(DesktopTable, {
          link: link,
          rows: children.get('rows'),
          width: width,
          height: adjustedHeight,
          setFilterCriteria: setFilterCriteria,
          filterCriteria: filterCriteria,
          config: config,
          preRowRender: preRowRender,
          customRowRenderer: customRowRenderer,
          onRowClick: onRowClick,
          rowHeight: rowHeight
        }, children);
      }));
    }
  }
}
export default DefiTable;